export default {
    imageDashboardTransaction: {
        action: 'Acción',
        transactionId: 'ID de Transacción',
        variationCount: 'Recuento de variantes',
        date: 'Fecha',
        cost: 'Costo',
        description: 'Descripción',
        selectedImage: 'Imagen seleccionada',
        goTo: 'Ir a',
    },
};
